import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import { authSlice } from './slices/authSlice';
import { uiSlice } from './slices/uiSlice';
import { apiSlice } from './api/apiSlice';
import casinoReducer from './slices/casinoGameDetailSlice';
import modalReducer from './slices/modalSlice';
import userReducer from './slices/userSlice';
import triggerReducer from './slices/triggerSlice';
import walletReducer from './slices/walletSlice';
import betReducer from './slices/betSlice';
import oneClickBetReducer from './slices/oneClickBetSlice';

export const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
    ui: uiSlice.reducer,
    api: apiSlice.reducer,
    casino: casinoReducer,
    modal: modalReducer,
    user: userReducer,
    betPlace: betReducer,
    trigger: triggerReducer,
    wallet: walletReducer,
    oneClickBet: oneClickBetReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }).concat(apiSlice.middleware),
  devTools: import.meta.env.DEV,
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Export action creators
export const { login, logout, setUser, setTokens, clearAuth } = authSlice.actions;
export const { setLoading, setError, clearError, setNotification, clearNotification } =
  uiSlice.actions;
export { openModal, closeModal } from './slices/modalSlice';
export { clearUser } from './slices/userSlice';
